module.exports = __webpack_public_path__ + "img/c5869e9.jpg";